import React, { useMemo } from "react"
import { Box, componentStyles } from "@mallardbay/lib-react-components"
import type { BoxProps } from "@mallardbay/lib-react-components"

export const RESPONSIVE_BLOCK_PADDING_X = [4, 4, 8, 8, 8]

interface Props extends BoxProps {
    readonly size?: "sm" | "md" | "lg" | "xl"
}

export default function ResponsiveBlock({ size, style, ...props }: Props) {
    const sizeStyle = useSizeStyle(size)

    const mergedStyle = componentStyles({
        root: { ...sizeStyle, ...style },
    })

    return <Box style={mergedStyle.root} {...props} />
}

function useSizeStyle(size?: Props["size"]) {
    return useMemo(
        () => ({
            px: RESPONSIVE_BLOCK_PADDING_X,
            mx: size ? "auto" : 0,
            maxW: getMaxWidth(size),
        }),
        [size]
    )
}

function getMaxWidth(size?: Props["size"]) {
    switch (size) {
        case "sm":
            return "768px"
        case "md":
            return "992px"
        case "lg":
            return "1280px"
        case "xl":
            return "1536px"
        default:
            return undefined
    }
}
